import React from "react";
import { shallowEqual } from "react-redux";
import * as Styles from "./styles/CarFilterHeaderStyles";
import { CarFilterLabel, useCarFilterLabel } from "../../../car-filter/utils/constants/labels";
import { useCarFilterSelector } from "../../../car-filter/redux/store";
import { getAemImageUrl, scrollTargetIntoView } from "../../../../common-deprecated/utils";
import { useAemNavOffset } from "../../../../common-deprecated/hooks";
import { UscContext } from "../../../shared-logic/types/UscCommonTypes";
import ButtonPrimary from "../../../../common-deprecated/components/aem/toyota/ButtonPrimary";
import { getToyotaButtonColor } from "../../../car-filter/utils/ctaUtils";
import TopFilters from "../../../car-filter/components/toyota/top-filters/TopFilters";
import { CAR_FILTER_ID } from "../../../car-filter/utils/constants/constants";

const CarFilterHeader = (): JSX.Element => {
    const resultCount = useCarFilterSelector((state) => state.carResults.totalResultCount);
    const filterContext = useCarFilterSelector((state) => state.carFilters.currentFilter);
    const commonSettings = useCarFilterSelector((state) => state.commonSettings);
    const { topFiltersBackgroundImageUrl } = useCarFilterSelector((state) => state.carFilterSettings, shallowEqual);
    const siteNavOffset = useAemNavOffset();

    const titleLabel = useCarFilterLabel(
        filterContext === UscContext.Used ? "carFilterHeaderTitleUsed" : "carFilterHeaderTitleStock",
    );

    const backgroundImage =
        getAemImageUrl(topFiltersBackgroundImageUrl, { wid: 1440, fit: "stretch" }) ||
        `${commonSettings.resourcePath}/toyota/img/car-filter/header/header.jpg`;

    return (
        <Styles.Wrapper backgroundImage={backgroundImage}>
            <Styles.Container>
                <header>
                    <Styles.Title>{titleLabel}</Styles.Title>
                    <Styles.Description>
                        <CarFilterLabel label="carFilterHeaderDescription" />
                    </Styles.Description>
                </header>
                <Styles.FilterWrapper>
                    <TopFilters />
                    <Styles.ButtonWrapper>
                        <ButtonPrimary
                            fullWidth
                            color={getToyotaButtonColor(filterContext)}
                            onClick={() => scrollTargetIntoView(CAR_FILTER_ID, siteNavOffset, false, true)}
                        >
                            <CarFilterLabel label="carFilterHeaderShowResults" params={{ value: resultCount }} />
                        </ButtonPrimary>
                    </Styles.ButtonWrapper>
                </Styles.FilterWrapper>
            </Styles.Container>
        </Styles.Wrapper>
    );
};

export default CarFilterHeader;
